import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-556d247a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "state" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", null, null, -1))
const _hoisted_5 = { class: "result" }
const _hoisted_6 = { class: "footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_t_button = _resolveComponent("t-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("p", null, [
          _hoisted_4,
          _createTextVNode(_toDisplayString(_ctx.$t('领取成功')), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("p", null, _toDisplayString(_ctx.detail.rightSuccessInfo), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("a", {
        class: "home",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goTeslaRightHome && _ctx.goTeslaRightHome(...args)))
      }, _toDisplayString(_ctx.$t('返回礼遇首页')), 1),
      _createVNode(_component_t_button, {
        class: "right-btn",
        theme: "primary",
        text: _ctx.$t('查看已领取礼遇'),
        onClick: _ctx.goCoupon
      }, null, 8, ["text", "onClick"])
    ])
  ]))
}